import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux";
import { selectModal } from "../../redux/modal/selectors";
import { closeModal } from "../../redux/modal/modalSlice";
import { ROUTE_LOGIN } from "../routes/routesConstants";
import { useHistory, useLocation } from "react-router-dom";
import { makeStyles, Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";

const useStyles = makeStyles((theme)=>({
    snackbar: {width: "90%"},
    root: {width: "100%", color: "#ccc"},
    info:{
      backgroundColor: theme.palette.info.light,
      color: "#000"
    },
    warning:{
      backgroundColor: theme.palette.warning.light,
      color: "#000"
    },
    error:{
      backgroundColor: theme.palette.error.light,
      color: "#000"
    },
    success:{
      backgroundColor: theme.palette.success.light,
      color: "#000"
    },
}))

function Modal(){


let modal = useSelector(selectModal);
const dispatch = useDispatch()
const history = useHistory()
const location = useLocation();
const classes = useStyles();
const open = modal.open && modal.message?.length > 0;

useEffect(()=>{
  if(modal.code === 401){
   history.push(ROUTE_LOGIN, location.state)
  }
},[modal])
 
function handleClose(){
dispatch(closeModal());
}
    return(
    <Snackbar classes={{root: classes.snackbar}} open={open} autoHideDuration={5000} onClose={handleClose}>
      <Alert classes={{root: classes.root, standardInfo: classes.info, standardError: classes.error, standardWarning: classes.warning, standardSuccess: classes.success}} 
                iconMapping={{info: <i className="icon icon-alert-info icon-black"></i>, success: <i className="icon icon-alert-success icon-black"></i>, warning: <i className="icon icon-alert-warning icon-black"></i>, error: <i className="icon icon-alert-error icon-black"></i> }} 
                severity={modal.type} 
                onClose={handleClose}
      >
          {modal.message}
      </Alert>
    </Snackbar>
    )
}

export {Modal}